import React from 'react';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import style from './button-with-lock-icon.module.css';
import { LockIconWithTooltip } from './lock-icon-with-tooltip';

/**
 * @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor
 * @typedef {import('ui-components/components/button/button-types.d.ts').ButtonThemeValues} ButtonThemeValues
 */

/**
 * A component that displays a lock icon with a tooltip inside of a button.
 * Used to visually indicate locked functionality throughout the application.
 * @param {object} props - The component props
 * @param {MessageDescriptor} [props.disabledTooltipMessage] - Custom message descriptor for the tooltip text when button is disabled
 * @param {boolean} [props.disabled] - Indicates if the button is disabled
 * @param {(event: object) => void} props.onClick - Function to call when the button is clicked
 * @param {boolean} [props.isLoading] - Whether the button should show a loading state
 * @param {ButtonThemeValues} [props.theme] - The theme of the button
 * @param {React.ReactNode} props.children - The content to display inside the button
 * @returns {JSX.Element} A div containing the button with lock icon
 */
export const ButtonWithLockIcon = ({ onClick, disabled, isLoading, theme = THEME_CONSTANTS.primary, children, disabledTooltipMessage }) => (
  <Button className={style['button-with-lock-icon']} disabled={disabled} isLoading={isLoading} onClick={onClick} theme={theme}>
    {disabled ? <LockIconWithTooltip iconClass={style.icon} tooltipMessageDescriptor={disabledTooltipMessage} /> : null}
    {children}
  </Button>
);
